export default class ElementScrollService {
    scrollToElement(query: string, speed: string = "slow") {
        const element = $(query);
        const scrollbar = this.getScrollParent(element.first());
        $(scrollbar).animate({ scrollTop: element.offset().top }, speed);
    }

    getScrollParent(node: JQuery) {
        const isElement = node.length && node.first();
        const overflowY = isElement && node.css("overflowY");
        const isScrollable = overflowY !== "visible" && overflowY !== "hidden";

        if (!node) {
            return null;
        } else if (isScrollable && node.prop("scrollHeight") >= node.prop("clientHeight")) {
            return node;
        }

        return this.getScrollParent(node.parent()) || $("body");
    }
}
